import { Portal } from '@ardoq/basic-components';
import { useModalPortalTarget, useStackPagePortalTarget } from '@ardoq/hooks';
import { FunctionComponent, PropsWithChildren } from 'react';
import { getDropdownMenuPortalTarget } from './utils';

export const OptionalPortal: FunctionComponent<
  PropsWithChildren<{ disablePortal?: boolean }>
> = ({ children, disablePortal }) => {
  const modalPortalTarget = useModalPortalTarget();
  const stackPagePortalTarget = useStackPagePortalTarget();
  if (disablePortal) return <>{children}</>;
  const target =
    modalPortalTarget ?? stackPagePortalTarget ?? getDropdownMenuPortalTarget();
  return <Portal to={target}>{children}</Portal>;
};
